export default __webpack_public_path__ + "static/media/element4Card.a5f5470b.svg";